export type SignupProductKey = 'wordly_wise' | 'ispire' | 'spire' | 'edventi' | 'xtra' | 'hopkinton';
export type SignupProductPlan = 'wordlywise' | 'ispire' | 'spire' | 'edventi' | 'xtra-weekly' | 'hopkinton';
export type DistrictAdminProductKey = Extract<SignupProductKey, 'wordly_wise' | 'ispire' | 'spire'>;

export interface SignupProductConfiguration {
  urlPlan: SignupProductPlan;
  productKey: SignupProductKey;
  label: string;
  logoAssetUrl: string;
  supportsDistrictAdmin: boolean;
}

// Non-district-admin product views temporarily replace legacy site signup pages. District-admin support remains an active invitation flow.
export const signupProductConfigurations: readonly SignupProductConfiguration[] = [
  {
    urlPlan: 'wordlywise',
    productKey: 'wordly_wise',
    label: 'Wordly Wise i3000',
    logoAssetUrl: 'https://www.exploros.com/content/images/2016/08/WW4D.png',
    supportsDistrictAdmin: true,
  },
  {
    urlPlan: 'ispire',
    productKey: 'ispire',
    label: 'iSPIRE',
    logoAssetUrl: 'https://www.exploros.com/content/images/2016/08/ispire.png',
    supportsDistrictAdmin: true,
  },
  {
    urlPlan: 'spire',
    productKey: 'spire',
    label: 'S.P.I.R.E.',
    logoAssetUrl: 'https://www.exploros.com/content/images/2016/08/SPIRE_logo.gif',
    supportsDistrictAdmin: true,
  },
  {
    urlPlan: 'edventi',
    productKey: 'edventi',
    label: 'Edventi',
    logoAssetUrl: 'https://www.exploros.com/content/images/2016/09/edventi-logo.svg',
    supportsDistrictAdmin: false,
  },
  {
    urlPlan: 'xtra-weekly',
    productKey: 'xtra',
    label: 'XTRA Weekly',
    logoAssetUrl: 'https://www.exploros.com/content/images/Curriculum/xtra-weekly/xtra_weekly.png',
    supportsDistrictAdmin: false,
  },
  {
    urlPlan: 'hopkinton',
    productKey: 'hopkinton',
    label: 'Hopkinton Vocabulary',
    logoAssetUrl: 'https://www.exploros.com/content/images/2017/Hopkinton.gif',
    supportsDistrictAdmin: false,
  },
];

export function getSignupProductByPlan(urlPlan: string | null): SignupProductConfiguration | null {
  return signupProductConfigurations.find((configuration) => configuration.urlPlan === urlPlan) || null;
}

export function getSignupProductByKey(productKey: SignupProductKey): SignupProductConfiguration {
  return signupProductConfigurations.find((configuration) => configuration.productKey === productKey)!;
}

export function isSignupProductKey(value: unknown): value is SignupProductKey {
  return signupProductConfigurations.some((configuration) => configuration.productKey === value);
}

export function isDistrictAdminProductKey(
  productKey: SignupProductKey | null,
): productKey is DistrictAdminProductKey {
  return productKey !== null && getSignupProductByKey(productKey).supportsDistrictAdmin;
}
